import { ANALYTICS_EVENTS, trackEvent } from '@/analytics';

export const handleLinkedInClick = () => {
  const eventData = {
    page: window.location.pathname,
    location: 'footer',
  };

  trackEvent(ANALYTICS_EVENTS.LINKEDIN_CLICKED, eventData);
};

export const handleInstagramClick = () => {
  const eventData = {
    page: window.location.pathname,
    location: 'footer',
  };

  trackEvent(ANALYTICS_EVENTS.INSTAGRAM_CLICKED, eventData);
};

export const handleTwitterClick = () => {
  const eventData = {
    page: window.location.pathname,
    location: 'footer',
  };

  trackEvent(ANALYTICS_EVENTS.TWITTER_CLICKED, eventData);
};

export const handleYouTubeClick = () => {
  const eventData = {
    page: window.location.pathname,
    location: 'footer',
  };

  trackEvent(ANALYTICS_EVENTS.YOUTUBE_CLICKED, eventData);
};
